import { Box, useTheme } from "@mui/material";
import * as React from "react";

import { EventDescriptionForm } from "@/shared/components/events/EventDescriptionForm";
import { EventRecord } from "@/shared/domain/events";

import styles from "./EditableEventDescription.module.css";
import { EventDescription } from "./EventDescription";

interface EditableEventDescriptionProps {
  event: EventRecord;
  readonly: boolean;
}

export function EditableEventDescription({
  event,
  readonly = false,
}: EditableEventDescriptionProps) {
  const theme = useTheme();

  const [isEditing, setIsEditing] = React.useState<boolean>(false);

  if (isEditing) {
    return (
      <EventDescriptionForm
        id={event.event_id}
        description={event.description}
        onSubmit={() => {
          setIsEditing(false);
        }}
        onCancel={() => setIsEditing(false)}
        inputClassName={styles.description}
      />
    );
  }

  return (
    <Box
      onClick={() => !readonly && setIsEditing(true)}
      sx={
        readonly
          ? {}
          : {
              ":hover": {
                backgroundColor: theme.palette.hoverBackground.main,
                borderRadius: "0.25rem",
                cursor: "pointer",
              },
            }
      }
    >
      <EventDescription description={event.description} readonly={readonly} />
    </Box>
  );
}
